import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Container, Row, Button } from 'reactstrap';

import './AuthenticationPage.css';
import './General.css';
import TeamChoice from './TeamChoice';
import Spinners from './Spinners';
import ErrorPage from './ErrorPage';
import Header from './Header';
// import Footer from './Footer';

class AuthenticationPage extends React.Component {
  constructor() {
    super();
    this.state = {
      pseudo: '',
      team: '',
      teams: [],
      teamsOpponent: [],
      isLoading: true,
      isError: false,
      error: {}
    };
    this.handleChangePseudo = this.handleChangePseudo.bind(this);
    this.handleChooseTeam = this.handleChooseTeam.bind(this);
    this.validateAuthentication = this.validateAuthentication.bind(this);
    this.storeImageOpponent = this.storeImageOpponent.bind(this);
  }

  handleChangePseudo(event) {
    const { value } = event.target;
    this.setState({ pseudo: value });
  }

  handleChooseTeam(event) {
    const choice = event.target.id;
    const newTeams = this.state.teams.map(el => {
      if (el.uuid === choice) {
        return { ...el, isClicked: !el.isClicked };
      }
      return { ...el, isClicked: false };
    });
    this.setState({ team: choice, teams: newTeams });
  }

  storeImageOpponent(event, logo) {
    localStorage.setItem('logoOpponent', logo);
    const choiceOpponent = event.target.id;
    const newTeamsOpponent = this.state.teamsOpponent.map(el => {
      if (el.uuid === choiceOpponent) {
        return { ...el, isClicked: !el.isClicked };
      }
      return { ...el, isClicked: false };
    });
    this.setState({ teamsOpponent: newTeamsOpponent });
  }

  validateAuthentication() {
    axios
      .post('https://c-clicker-api.herokuapp.com/users', {
        pseudo: this.state.pseudo,
        team: this.state.team
      })
      .then(response => {
        localStorage.setItem('uuid', `${response.data.uuid}`);
        setTimeout(() => {
          this.props.history.push('/mainPagePlay');
        }, 200);
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
  }

  componentDidMount() {
    axios
      .get('https://c-clicker-api.herokuapp.com/teams')
      .then(res => {
        const datas = res.data;
        this.setState({ teams: datas, isLoading: false });
      })
      .then(() => {
        const newTeams = this.state.teams.map(team => {
          return { ...team, isClicked: false };
        });
        this.setState({ teams: newTeams, teamsOpponent: newTeams });
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
  }

  render() {
    const { pseudo, teams, teamsOpponent, isLoading, isError, error } = this.state;

    if (isLoading) {
      return <Spinners />;
    } else if (isError) {
      return <ErrorPage error={error} />;
    } else {
      return (
        <Container fluid className="d-flex flex-column min-vh-100 vw-100 align-items-center">
          <Header />
          <Container className="vh-100 flex-column justify-content-center m-perso">
            <Container className="w-container flex-column justify-content-center border border-white rounded">
              <Row className="justify-content-center pb-5 pt-5">
                <h1>Authentification</h1>
              </Row>

              <Row className="flex-column mx-1 mb-4 p-light">
                <label htmlFor="pseudo">Entre ton pseudo :</label>
                <input
                  type="text"
                  id="pseudo"
                  name="pseudo"
                  value={pseudo}
                  placeholder="Pseudo"
                  onChange={this.handleChangePseudo}
                />
              </Row>

              <TeamChoice teams={teams} onClick={this.handleChooseTeam} title="Choisis ta team" />

              <TeamChoice
                teams={teamsOpponent}
                onClick={this.storeImageOpponent}
                title="Choisis la team que tu souhaites boxer"
              />

              <Row className="d-flex justify-content-center mx-1 mb-3">
                <p className="p-light">
                  Tu ne trouves pas ton langage favori ? Ou tu ne trouves pas le langage que tu
                  souhaites boxer ? <Link to="/createNewTeam">Créé une nouvelle team</Link>
                </p>
              </Row>

              <Row className="justify-content-center mb-3">
                <Button color="warning" onClick={this.validateAuthentication}>
                  Fight !!!
                </Button>
              </Row>
            </Container>
          </Container>
          {/* <Row className="row-footer vw-100 justify-content-center align-items-center mt-5">
            <Footer />
          </Row> */}
        </Container>
      );
    }
  }
}

export default AuthenticationPage;
